import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/identities', { params });
  },
  createData() {
    return Backend.get('/identities/create');
  },
  editData(id) {
    return Backend.get(`/identities/${id}/edit`);
  },
  create(data) {
    return Backend.post('/identities/', data);
  },
  update(data) {
    return Backend.put(`/identities/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/identities/${id}`);
  },
};
